import axios from 'axios';
import { useInterval } from 'hooks';
import { isEmpty } from 'lodash';
import {
	useEffect,useState
} from 'react';

export default function useNPHourTracker({
	csrfToken, viewType, action, patientId, patientState,
}, logPageView = true, allowLogHeartbeat = true) {
	const [pageViewData] = useState({
		url: window.location.pathname,
		viewType,
	});
	const heartbeatLimit = 3; // number of heartbeats to send after page init
	const [numberHeartbeats, setNumberHeartbeats] = useState(0);

	async function initPageView() {
		const data = {};
		if (action) data.action = action;
		if (patientId) data.patient_id = patientId;
		if (patientState) data.patient_state = patientState;
		setNumberHeartbeats(0);
		await log(data,
			'INIT PAGE VIEW');
	}

	async function logHeartbeat() {
		setNumberHeartbeats(numberHeartbeats + 1);
		await log({ action: 'HEARTBEAT' },
			'HEARTBEAT');
	}
	async function logAction(actionType, data = {}) {
		const actionData = { action: actionType };
		if (!isEmpty(data)) {
			if (data.patientId) actionData.patient_id = data.patientId;
			if (data.patientState) actionData.patient_state = data.patientState;
		}
		return await log(actionData,
			'ACTION');
	}

	async function log(data, type) {
		console.info('LOGGING ' + type)
		const {
			viewType, url,
		} = pageViewData;
		try {
			const res = await axios({
				url: '/ajax/user/log_page_view_heartbeat/',
				method: 'POST',
				data: {
					url,
					view_type: viewType,
					...data,
				},
				headers: {
					X_CSRFTOKEN: csrfToken,
				},
			});
			if (res.error) throw new Error(res.error);
			if (!res.data) throw new Error('Request failed');
			console.log(`SUCCESS LOGGING ${type}`,
				res.data?.response);
		} catch (error) {
			console.error(`ERROR WHILE LOGGING ${type}`,
				error.message);
		}
	}

	useEffect(() => {
		// Allow ability to prevent react app from logging a dupe page view (e.g. Backbone App on Doctor dash is logging an init pageView)
		if (logPageView) {
			initPageView()
		}
	},
	[]);

	useInterval(() => {
		// Allow ability to prevent dupe heartbeat (e.g. Backbone app for Doctor dash is handling the heartbeat)
		if (allowLogHeartbeat) {
			logHeartbeat()
		}
	},
	numberHeartbeats < heartbeatLimit ? 60000 : null); // only log heartbeats up to the heartbeatLimit after page init

	return [logAction];
}
